import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftSalesManagementIndexResponse } from '@/repositories/generated';

const content: GiftSalesManagementIndexResponse[] = [
  {
    giftSalesManagementId: '0018',
    giftSalesManagementName: '青森市商品券（第1期）',
    salesStatus: 'ENDED',
    entryStatus: 'ENDED',
    salesStartsAt: '2025-05-01T00:00:00+09:00',
    salesEndsAt: '2025-07-31T00:00:00+09:00',
    entryStartsAt: '2025-04-01T00:00:00+09:00',
    entryEndsAt: '2025-04-30T23:59:59+09:00',
    expiresStartsAt: '2025-05-01T00:00:00+09:00',
    expiresEndsAt: '2025-10-31T23:59:59+09:00',
    salesCount: 15000,
    salesPerAmount: 10000,
    premiumRate: 0.25,
    totalGrantedPerAmount: 12500,
    tickets: [
      {
        giftTicketId: '0055',
        giftTicketName: '青券（中小・一般店のみで利用可）',
        totalAmount: 7500,
        prepaidValue: 6000,
        bonusValue: 1500,
      },
      {
        giftTicketId: '7777',
        giftTicketName: '赤券（大型店・一般店で利用可能）',
        totalAmount: 5000,
        prepaidValue: 4000,
        bonusValue: 1000,
      },
    ],
  },
  {
    giftSalesManagementId: '0022',
    giftSalesManagementName: '青森市商品券（第2期）',
    salesStatus: 'ON_SALE',
    entryStatus: 'ENDED',
    salesStartsAt: '2024-10-01T00:00:00+09:00',
    salesEndsAt: '2024-12-31T00:00:00+09:00',
    entryStartsAt: '2024-09-01T00:00:00+09:00',
    entryEndsAt: '2024-09-30T23:59:59+09:00',
    expiresStartsAt: '2024-10-01T00:00:00+09:00',
    expiresEndsAt: '2025-03-31T23:59:59+09:00',
    salesCount: 10000,
    salesPerAmount: 10000,
    premiumRate: 0.255,
    totalGrantedPerAmount: 12500,
    tickets: [],
  },
  {
    giftSalesManagementId: '0031',
    giftSalesManagementName: '青森市商品券（第3期）',
    salesStatus: 'NOT_STARTED',
    entryStatus: 'OPEN',
    salesStartsAt: '2024-07-30T00:00:00+09:00',
    salesEndsAt: '2024-12-31T00:00:00+09:00',
    entryStartsAt: '2024-07-01T00:00:00+09:00',
    entryEndsAt: '2024-07-29T23:59:59+09:00',
    expiresStartsAt: '2024-07-30T00:00:00+09:00',
    expiresEndsAt: '2025-03-31T23:59:59+09:00',
    salesCount: 10000,
    salesPerAmount: 10000,
    premiumRate: 0.2,
    totalGrantedPerAmount: 12500,
    tickets: [],
  },
];

const loopContent = new Array<string>(10)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const giftSalesManagement = http.get(
  createMockEndpoint('/gift_sales_management'),
  async () => {
    await delay(500);
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: { empty: true, sorted: false, unsorted: true },
        offset: 0,
        pageNumber: 0,
        pageSize: 10,
        paged: true,
        unpaged: false,
      },
      last: false,
      totalPages: 2,
      totalElements: 15,
      size: 10,
      number: 0,
      sort: { empty: true, sorted: false, unsorted: true },
      first: true,
      numberOfElements: 10,
      empty: false,
    }, { status: 200 });
  },
);
